import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reads the current query parameters.
 */
export default function useQueryParameters(): URLSearchParams {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
